// Lightweight analytics dispatcher. Pushes to dataLayer (GTM/GA4) and Meta Pixel
// when configured, and always no-ops safely when IDs are not set yet.

export function track(event, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", event, params);
    }
  } catch (e) {
    /* analytics must never break the UI */
  }
}

export function getUTMParams() {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source"),
    utm_medium: p.get("utm_medium"),
    utm_campaign: p.get("utm_campaign"),
  };
}
